import React, { useEffect, useState } from 'react';
import axios from 'axios';

const monthNames = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

const Commodity_Enable_Disable = () => {
  const [monthsYears, setMonthsYears]             = useState([]);
  const [alotMonthsYears, setAlotMonthsYears]     = useState([]);
  const [distinctAlotMonths, setDistinctAlotMonths] = useState([]);
  const [distinctAlotYears,  setDistinctAlotYears]  = useState([]);
  const [commodities, setCommodities]             = useState([]);

  const [formData, setFormData] = useState({
    month: '', year: '', 
    alotMonth: '', alotYear: '',
    commId: '', status: 'A'
  });
  const [originalStatus, setOriginalStatus] = useState('');
  const [lastSubmitted, setLastSubmitted]   = useState(null);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_URL}/api/form/months-years`).then(r => setMonthsYears(r.data));
    axios.get(`${process.env.REACT_APP_URL}/api/form/alot-months-years`).then(r => setAlotMonthsYears(r.data));
    axios.get(`${process.env.REACT_APP_URL}/api/form/alot-months`).then(r => setDistinctAlotMonths(r.data));
    axios.get(`${process.env.REACT_APP_URL}/api/form/alot-years`).then(r => setDistinctAlotYears(r.data));
}, []);

useEffect(() => {
    const { month, year, alotMonth, alotYear } = formData;
    if (month && year && alotMonth && alotYear) {
        axios.get(`${process.env.REACT_APP_URL}/api/form/commodities`, {
            params: { month, year, alotMonth, alotYear }
        })
        .then(r => setCommodities(r.data));
      setFormData(fd => ({ ...fd, commId: '', status: 'A' }));
      setOriginalStatus('');
      setLastSubmitted(null);
    }
  }, [formData.month, formData.year, formData.alotMonth, formData.alotYear]);

  const handleChange = e => {
    const { name, value } = e.target;
    if (name === 'commId') {
      const sel = commodities.find(c => c.commId === +value) || {};
      setFormData(fd => ({ ...fd, commId: value, status: sel.status || 'A' }));
      setOriginalStatus(sel.status || 'A');
      setLastSubmitted(null);
    } else {
      setFormData(fd => ({ ...fd, [name]: value }));
    }
  };

  const handleSubmit = async () => {
    const payload = {
      ...formData,
      month:     +formData.month,
      year:      +formData.year,
      alotMonth: +formData.alotMonth,
      alotYear:  +formData.alotYear,
      commId:    +formData.commId
    };

    if (lastSubmitted 
        && JSON.stringify(lastSubmitted) === JSON.stringify(payload)) {
      return alert('No changes—already updated');
    }
    if (payload.status === originalStatus && lastSubmitted === null) {
      return alert(originalStatus === 'A' ? 'Already enabled' : 'Already disabled');
    }
try {
    await axios.post(`${process.env.REACT_APP_URL}/api/form/save`, payload);
      alert('Submitted successfully');
      setLastSubmitted(payload);
      setOriginalStatus(payload.status);
    } catch {
      alert('Submission failed');
    }
  };

  return (
    <div className="wrapper row3" style={{ maxHeight: '95vh', overflowY: 'auto', paddingBottom: '40px' }}>
      <div id="container">
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px' }}>
          <table width="40%">
            <thead>
              <tr className="tableheader">
                <th colSpan={12} style={{ textAlign: 'center', fontWeight: 'bold' }}>
                  COMMODITY enable/disable
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><label>Month:</label></td>
                <td>
                  <select name="month" value={formData.month} onChange={handleChange}>
                    <option value="">Select Month</option>
                    {monthsYears.map(([m, y], i) =>
                      <option key={i} value={m}>{monthNames[m-1]}</option>
                    )}
                  </select>
                </td>

                <td><label>Year:</label></td>
                <td>
                  <select name="year" value={formData.year} onChange={handleChange}>
                    <option value="">Select Year</option>
                    {monthsYears.map(([m, y], i) =>
                      <option key={i} value={y}>{y}</option>
                    )}
                  </select>
                </td>

                <td><label>Allot Month:</label></td>
                <td>
                  <select name="alotMonth" value={formData.alotMonth} onChange={handleChange}>
                    <option value="">Select Allot Month</option>
                    {distinctAlotMonths.map(m =>
                      <option key={m} value={m}>{monthNames[m-1]}</option>
                    )}
                  </select>
                </td>

                <td><label>Allot Year:</label></td>
                <td>
                  <select name="alotYear" value={formData.alotYear} onChange={handleChange}>
                    <option value="">Select Allot Year</option>
                    {distinctAlotYears.map(y =>
                      <option key={y} value={y}>{y}</option>
                    )}
                  </select>
                </td>

                <td><label>Commodity:</label></td>
                <td>
                  <select name="commId" value={formData.commId} onChange={handleChange}>
                    <option value="">Select Commodity</option>
                    {commodities.map(c =>
                      <option key={c.commId} value={c.commId}>{c.commNameEn}</option>
                    )}
                  </select>
                </td>

                <td><label>Status:</label></td>
                <td>
                  <select name="status" value={formData.status} onChange={handleChange}>
                    <option value="A">Enable</option>
                    <option value="N">Disable</option>
                  </select>
                </td>
              </tr>
              <tr>
                <td colSpan={12} style={{ textAlign: 'center', paddingTop: '1rem' }}>
                  <button type="button" className="button button2" onClick={handleSubmit}>
                    Submit
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Commodity_Enable_Disable;
